



































import { Component, Prop, Vue } from 'vue-property-decorator';
import UserService from '@/services/UserService';

@Component
export default class Login extends Vue {
    private Username: string = '';
    private Password: string = '';

    private HasError: boolean = false;

    private async PerformLogin() {
        const userService = new UserService();

        const response: any = await userService.Login(this.Username, this.Password);
        if (response.Error === true) {
            this.HasError = true;
            // return;
        } else {
            this.HasError = false;
        }
        if (response.Data.IsAdmin === true) {
            this.$router.push('/admin');
        } else {
        // redirect to home page.
            this.$router.push('/');
        }

        // const usrInfo: UserInfo = new UserInfo();
        // this.hasErrors = false;
        // // Prepare the object with the post data.
        // const postData = {
        //     Username: this.Username,
        //     Password: this.Password,
        // };

        // // Authenticate on server
        // const endpoint = this.$store.state.serverUrl + this.$store.state.login;
        // this.$http.post(endpoint, postData).then((response: AxiosResponse) => {

        //     usrInfo.Id = response.data.Id;
        //     usrInfo.AccountTypeId = response.data.AccountTypeId;
        //     usrInfo.AccountId = response.data.AccountId;
        //     usrInfo.FirstName = response.data.FirstName;
        //     usrInfo.LastName = response.data.LastName;
        //     usrInfo.UserName = response.data.UserName;
        //     usrInfo.UserToken = response.data.Usr_Token;
        //     usrInfo.UserRole = response.data.RoleId;

        //     this.$store.commit('setUserInfo', usrInfo);
        //     this.$store.commit('setUserToken', usrInfo.UserToken);

        //     // Get the Date and set next Expiry Time
        //     const today = new Date();
        //     today.setMinutes(today.getMinutes() +
        //         this.$store.state.userTokenInactivityExpirationMinutes);
        //     this.$store.commit('setUserTokenExpiryDate', today);

        //     if (this.$route.query.redirect != null) {
        //         const target: string = this.$route.query.redirect as string;
        //         this.$router.push(target);
        //     } else {
        //         // redirect to home page.
        //         this.$router.push('/');
        //     }

        //     // Reload the Configuration based on the logged in user
        //     this.ReloadConfigurationAndMenu();

        // })
        // .catch((response) => {
        //     this.hasErrors = true;
        //     // console.log(response.response.data);
        //     this.loginError = response.response.data.message;
        // //  console.log(this.loginError);
        //  });
    }
}
